import React, { Component } from 'react';
import Router from './markup/router';
import './App.css';

class App extends Component {
  
  render() {
    return (
      <div className="App">
        <Router />
      </div>
    );
  }
}

export default App;
